// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"hLoj6j","Footer":"dkYYmT","Logo":"g7__qz","Copy":"rEgcW5","Hub":"ewUPQG","Links":"jKJ09b","Icone":"GLuzmT"};